import React, { Component } from "react";
import { Button, Message } from "semantic-ui-react";

import { getErrorMessage, getErrorCode } from "../../../../utils/api_error";

const COOLDOWN_SECONDS = 30;

// Flow-agnostic: the caller supplies `resend`, a function of
// (pendingToken, callback), so login and password-change share this control.
class OtpResendControl extends Component {
  state = {
    secondsLeft: COOLDOWN_SECONDS,
    sending: false,
    message: "",
    messageIsError: false,
  };

  componentDidMount() {
    this.startCooldown();
  }

  componentWillUnmount() {
    clearInterval(this.cooldownTimer);
  }

  // Counts down against a fixed deadline rather than decrementing a number:
  // browsers throttle timers in background tabs, and a decrementing counter
  // drifts badly when that happens.
  startCooldown = () => {
    clearInterval(this.cooldownTimer);
    this.cooldownEndsAt = Date.now() + COOLDOWN_SECONDS * 1000;
    this.setState({ secondsLeft: COOLDOWN_SECONDS });
    this.cooldownTimer = setInterval(() => {
      const secondsLeft = Math.max(
        0,
        Math.ceil((this.cooldownEndsAt - Date.now()) / 1000)
      );
      if (secondsLeft === 0) {
        clearInterval(this.cooldownTimer);
      }
      this.setState({ secondsLeft });
    }, 1000);
  };

  handleResend = () => {
    this.setState({ sending: true, message: "", messageIsError: false });
    this.props.resend(
      this.props.pendingToken,
      (result, error) => {
        if (error) {
          const errorCode = getErrorCode(error);
          const errorMessage = getErrorMessage(
            error,
            "We could not resend the code. Please try again."
          );
          // A dead session cannot be recovered from here - hand it back up so
          // the whole flow restarts at the password step.
          if (
            errorCode === "SESSION_INVALID" ||
            errorCode === "CHALLENGE_EXPIRED" ||
            errorCode === "OTP_RESEND_LIMIT"
          ) {
            this.props.onSessionLost(errorMessage);
            return;
          }
          // Restarting the full window is always at least the server's
          // remaining window, so the next attempt cannot be rejected again.
          // Beats scraping the seconds out of a human-readable string.
          this.setState({
            sending: false,
            message: errorMessage,
            messageIsError: true,
          });
          this.startCooldown();
          return;
        }
        // The server may return the same prefix (it re-sends the same code) or
        // a new one; either way the display must follow the latest response.
        this.props.onResent(result);
        this.setState({
          sending: false,
          message: "A new code has been sent to your email.",
          messageIsError: false,
        });
        this.startCooldown();
      }
    );
  };

  render() {
    const { secondsLeft, sending, message, messageIsError } = this.state;
    const waiting = secondsLeft > 0;
    return (
      <div>
        <Button
          type="button"
          basic
          fluid
          size="small"
          style={{
            marginTop: "1.5em",
            padding: 0,
            boxShadow: "none",
          }}
          disabled={waiting || sending}
          loading={sending}
          onClick={this.handleResend}>
          {waiting ? `Resend code in ${secondsLeft}s` : "Resend code"}
        </Button>
        {message && (
          <Message
            size="tiny"
            negative={messageIsError}
            positive={!messageIsError}>
            {message}
          </Message>
        )}
      </div>
    );
  }
}

export default OtpResendControl;
